import styled, { css } from "styled-components";

import { Input } from "components/ui";
import {
    StyledInput,
    InputWrapper as TextInputWrapper
} from "components/ui/input/Input.styled";

import { media } from "constants/media";

export const LeftContentTitle = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    > h5 {
        font-size: 18px;
        font-weight: bold;
        line-height: 32px;
    }

    > span {
        color: var(--color-grey-55);
        cursor: pointer;
        font-size: 15px;
        font-weight: 800;
        line-height: 24px;

        &:hover {
            color: var(--color-primary);
        }
    }
`;

export const Filter = styled.div``;

export const FilterTitle = styled.div`
    font-weight: bold;
    margin-bottom: 4px;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;

    input {
        cursor: pointer;
        margin: 8px 0;
        margin-right: 16px;
    }

    label {
        align-items: center;
        display: flex;
        font-size: 15px;
        justify-content: flex-start;
        line-height: 24px;
    }
`;

export const ButtonGroup = styled.div`
    --container-padding: 48px;

    align-items: center;
    background-color: var(--color-white);
    bottom: 0;
    display: flex;
    gap: 4px;
    justify-content: space-between;
    padding: 24px 0;
    position: fixed;
    transition: transform var(--default-transition-duration) ease;
    transition-delay: var(--default-transition-duration);
    width: calc(100vw - var(--container-padding));

    &.button-group-hidden {
        opacity: 0;
        transform: translateY(100px);
    }

    &.button-group-visible {
        transform: translateY(0);
    }

    span {
        white-space: nowrap;
    }

    ${media.mdUp} {
        display: none;
    }
`;

export const StyledTextInput = styled(Input)`
    height: 36px;
    margin-bottom: 16px;

    ${TextInputWrapper} {
        height: 32px;
    }

    ${StyledInput} {
        height: 32px;
    }
`;

export const RegionFilterWrapper = styled.div<{
    isScrolled: boolean;
    maxHeight: number;
}>`
    max-height: ${({ maxHeight }) => `${maxHeight}px`};
    ${({ isScrolled }) =>
        !isScrolled &&
        css`
            box-shadow: 0px 10px 18px -20px var(--color-grey-60);
        `}

    overflow-y: auto;
`;
